(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('textWrapper', textWrapper);

    function textWrapper() {
        return {
            restrict: 'E',
            scope: {
                'wrapperLabel': '='
            },
            transclude: true,
            link: function(scope) {
                if (!scope.wrapperLabel || scope.wrapperLabel.length === 0) {
                    scope.wrapperLabelPrefix = '';
                    scope.wrapperLabelSuffix = '';
                } else {
                    var splitted = scope.wrapperLabel.split('<content>');
                    if (splitted.length === 1) {
                        scope.wrapperLabelPrefix = splitted[0];
                    } else {
                        scope.wrapperLabelPrefix = splitted[0];
                        scope.wrapperLabelSuffix = splitted[1];
                    }
                }
            },
            template: '<div><%wrapperLabelPrefix%><ng-transclude></ng-transclude><%wrapperLabelSuffix%></div>'
        };
    }
})();